module.exports = __webpack_public_path__ + "img/mercury.be5030ca.webp";